import { jsx as _jsx } from "react/jsx-runtime";
export function SafeArea({ children, className = '', hasNav = false }) {
    return (_jsx("div", { className: `absolute inset-0 flex flex-col overflow-y-auto overflow-x-hidden no-scrollbar tg-safe ${hasNav ? 'pb-20' : ''} ${className}`, style: { background: '#0A0A0A' }, children: children }));
}
